// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BusinessProjectRequestsContainer_wrap__3yXf9","title":"BusinessProjectRequestsContainer_title__3qUSU","historyPopUp":"BusinessProjectRequestsContainer_historyPopUp__2fz1e"};